import { sendRequest } from "../../hooks/requests/useRequest";


export async function getAllQc() {
    const requestOptions = {
        method: 'GET'
    };

    const response = await sendRequest(requestOptions, `CancellationReazonSample/ListQs`);

    if (response.code === 200)
        return {
            data: response.data,
            msg: response?.msg,
            code: response.code,
        }
    else if (response.code === 401)
        return {
            data: response.data,
            msg: response?.msg,
            code: response.code,
        }
    else
        return {
            data: response.data,
            msg: response?.msg,
            code: response.code,
        }
}



export async function CreateCatalogsQs({
    quality_controL
}) {
    const body = {
        quality_controL
    };

    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, "CancellationReazonSample/CreateQsReasons"
    );

    if (response.code === 200)
        return {
            data: response.data,
            msg: response?.msg,
            code: response.code,
        }
    else if (response.code === 401)
        return {
            data: response.data,
            msg: response?.msg,
            code: response.code,
        }
    else
        return {
            data: response.data,
            msg: response?.msg,
            code: response.code,
        }
}



export async function UpdateCatalogsQc({
    id_qc_reasons, quality_controL
}) {

    let body = {
        id_qc_reasons: id_qc_reasons,
        quality_controL: quality_controL,
    };

    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, `CancellationReazonSample/UpdateQsReasons`
    );

    if (response.code === 200)
        return {
            data: response.data,
            msg: response?.msg,
            code: response.code,
        }
    else if (response.code === 401)
        return {
            data: response.data,
            msg: response?.msg,
            code: response.code,
        }
    else
        return {
            data: response.data,
            msg: response?.msg,
            code: response.code,
        }
}


export async function DeleteCatalogsQc({
    id_qc_reasons
}) {

    const requestOptions = {
        method: 'DELETE',
    };

    const response = await sendRequest(
        requestOptions, `CancellationReazonSample/DeleteQsReasons/${id_qc_reasons}`
    );

    if (response.code === 200)
        return {
            data: response.data,
            msg: response?.msg,
            code: response.code,
        }
    else if (response.code === 401)
        return {
            data: response.data,
            msg: response?.msg,
            code: response.code,
        }
    else
        return {
            data: response.data,
            msg: response?.msg,
            code: response.code,
        }
}